import { Component, Input, OnInit } from '@angular/core';
import { Table } from '../../../../models/reporting';
import { ReportingService } from '../../../../services/reporting.service';

@Component({
// tslint:disable-next-line: component-selector
    selector: 'detailed-linear-table',
    templateUrl: './detailed-linear-table.component.html',
    styleUrls: ['./table.component.scss']
})
export class DetailedLinearTableComponent implements OnInit {
    @Input() table: Table;

    constructor(private reportingService: ReportingService) {
        
     }

     ngOnInit() {
console.log(this.table);
     }

    getTitle(participantCategoryNameType: number): string {
        return this.reportingService.getParticipantCategoryTitle(participantCategoryNameType);
    }
}